module.exports = __webpack_public_path__ + "static/media/egg-fried.6fda7061.svg";